<template>
  <CButton
    :disabled
    :theme="active ? activeTheme : inactiveTheme"
    @click.prevent="active = !active"
    :link="attrs.link ?? undefined"
    class="c-toggle-button"
    :class="[active && 'c-toggle-button-active', attrs.class]"
  >
    <slot :active="active" />
  </CButton>
</template>

<script setup lang="ts">
  import { useAttrs } from 'vue';
  import CButton, { Theme } from './CButton.vue';

  const attrs = useAttrs();

  defineOptions({
    inheritAttrs: false,
  });

  const active = defineModel('active');

  withDefaults(
    defineProps<{
      activeTheme?: Theme;
      inactiveTheme?: Theme;
      disabled?: boolean;
    }>(),
    {
      activeTheme: 'main-primary',
      inactiveTheme: 'normal-primary',
    },
  );
</script>

<style lang="scss">
.c-toggle-button {
  &.c-button-disabled {
    background-color: $input-bg-disabled;
  }

  &.c-button-main-primary {
    padding: 0.5rem 0.75rem;
  }

  &-active {
    &.c-button-disabled {
      background-color: $input-bg-disabled;
    }
  }
}
</style>
